import tracking from '../lib/tracking';
import global from './global';

export default function() {
    $(function() {
        global();

        function viewURL(url) {
            window.open(url, '_blank', 'location=yes,height=750,width=1100,scrollbars=yes,status=yes');
        }

        let groupData = window.FC.group || {},
            partNumber = groupData.partNumber || '',
            manufacturer = groupData.manufacturer || '',
            trackValue = [encodeURIComponent(partNumber), encodeURIComponent(manufacturer)].join('|');

        $('.cad-models-list a').on('click', function(e) {

            e.preventDefault();
            viewURL($(this).attr('href'));
        });

        $('.j-part-request-form').on('submit', function(e) {

            e.preventDefault();

            let $success = $('.j-part-request-success'),
                $error = $('.j-part-request-error'),
                $loader = $('.j-cad-models .loading'),
                $this = $(this);

            $success.hide();
            $error.hide();
            $loader.show();

            $error.text('Something went wrong, please try again.');

            $.ajax({
                url: $this.attr('action'),
                data: $this.serialize(),
                type: 'post'
            }).done(function(data) {
                if (data && data.response) {
                    let response = data.response,
                        isNote = (response.toLowerCase().indexOf('note:') !== -1),
                        isError = (response.toLowerCase().indexOf('error:') !== -1);

                    if (isNote || isError) {
                        $error.text(response);
                        $error.show();
                        tracking.recordCadModelEvent('requesterror', trackValue + '|' + encodeURIComponent(response.toString()), '');
                    } else {
                        $this.hide();
                        $success.show();
                        tracking.recordCadModelEvent('requestsuccess', trackValue, '');
                    }
                } else {
                    $error.show();
                    tracking.recordCadModelEvent('requesterror', trackValue, '');
                }
            }).fail(function() {
                $error.show();
                tracking.recordCadModelEvent('requesterror', trackValue, '');
            }).always(function() {
                $loader.hide();
            });

            // track request event
            tracking.recordCadModelEvent('request', trackValue, '');
        });

        // track download event
        $('.j-cad-models-download').on('click', function(e) {
            e.preventDefault();
            
            let $this = $(this);
            let type = $this.data('type') || 'default';

            tracking.recordCadModelEvent('download', trackValue + '|' + encodeURIComponent(type), '');
            tracking.ckEventUrl($this.attr('data-url'), function() {
                window.location = $this.attr('href');
            });
        });

        $('.j-cad-models-content a').on('click', function() {

            let $this = $(this),
                $parent = $this.closest('.j-cad-models-content');

            let type = $parent.data('type') || 'default';

            tracking.recordCadModelEvent('open', trackValue + '|' + encodeURIComponent(type), '');
        });
    });
}